import { ld } from "@/lib/theme/light-dark";
import { FileText } from "lucide-react";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";

export function HeroVorgangAttachment(props: {
  readonly fileName: string;
}): ReactNode {
  const t = useTranslations("marketing.heroVorgangAttachment");
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "12px 14px",
        background: ld("#fff", "#181b1f"),
        border: `1px solid ${ld("#ECEDF0", "#2f3236")}`,
        borderRadius: 12,
        maxWidth: "78%",
        alignSelf: "flex-start",
      }}
    >
      <span
        style={{
          width: 40,
          height: 40,
          borderRadius: 8,
          background: ld("#FEF2F2", "#302727"),
          color: ld("#DC2626", "#fe7f73"),
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <FileText width={20} height={20} strokeWidth={1.8} />
      </span>
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: ld("rgba(11,15,25,0.45)", "rgba(250,250,250,0.45)"),
          }}
        >
          {t("pdf")}
        </div>
        <div
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: ld("#0B0F19", "#fafafa"),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {props.fileName}
        </div>
      </div>
    </div>
  );
}
